export class Scroller {
    static Top() {
        ($("html, body") as any).animate({ scrollTop: 0 }, "fast");
    }
}